export default "__VITE_ASSET__BlGDbsmd__"